import { createAction } from '@reduxjs/toolkit'

import * as types from './types'

export const showAlertMessage = createAction(types.SHOW_ALERT_MESSAGE)
export const hideAlertMessage = createAction(types.HIDE_ALERT_MESSAGE)
